import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEn from './locales/en/common.json';
import commonEs from './locales/es/common.json';
import authEn from './locales/en/auth.json';
import authEs from './locales/es/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardEs from './locales/es/dashboard.json';
import settingsEn from './locales/en/settings.json';
import settingsEs from './locales/es/settings.json';
import fundingEn from './locales/en/funding.json';
import fundingEs from './locales/es/funding.json';
import treasuryEn from './locales/en/treasury.json';
import treasuryEs from './locales/es/treasury.json';
import paymentsEn from './locales/en/payments.json';
import paymentsEs from './locales/es/payments.json';
import locEn from './locales/en/loc.json';
import locEs from './locales/es/loc.json';

// Define resources type for better TypeScript support
export const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    settings: settingsEn,
    funding: fundingEn,
    treasury: treasuryEn,
    payments: paymentsEn,
    loc: locEn,
  },
  es: {
    common: commonEs,
    auth: authEs,
    dashboard: dashboardEs,
    settings: settingsEs,
    funding: fundingEs,
    treasury: treasuryEs,
    payments: paymentsEs,
    loc: locEs,
  },
} as const;

// Language detection configuration
const detectionOptions = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'settings', 'funding', 'treasury', 'payments', 'loc'],
    
    detection: detectionOptions,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false, // Disable suspense for easier error handling
    },
    
    // Log missing translations in development
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lngs: readonly string[], ns: string, key: string) => {
      if (import.meta.env.DEV) {
        console.warn(`Missing translation: [${lngs}] ${ns}:${key}`);
      }
    },
  });

export default i18n;

// Helper function to update language when user.locale changes
export const updateLanguage = async (locale: string) => {
  if (locale && ['en', 'es'].includes(locale)) {
    await i18n.changeLanguage(locale);
    localStorage.setItem('i18nextLng', locale);
  }
};

// Helper function to detect language from browser if not authenticated
export const detectBrowserLanguage = (): string => {
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('es')) {
    return 'es';
  }
  return 'en';
};
